import _ from 'lodash';
import React, {FC} from 'react';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {InboxesCell} from '../../components/common/table/cells/inboxesCell';
import {TableCellProps} from '../../components/common/table/cells/tableCell';
import {makeMapStateToProps, ResolveStateProps} from '../../helpers/reselectHelpers';
import {AnswerModel} from '../../models/api/answerModel';
import {AppState} from '../../store/appState';
import {getInboxes} from '../../store/data/inboxes/inboxesSelectors';

/*
 * Props.
 */

interface SettingsAnswersInboxesCellContainerProps extends TableCellProps<AnswerModel> {}

interface SettingsAnswersInboxesCellProps
  extends SettingsAnswersInboxesCellContainerProps,
    ResolveStateProps<typeof mapStateToProps> {}

/*
 * Selectors.
 */

function getAnswer(_state: AppState, props: SettingsAnswersInboxesCellContainerProps) {
  return props.value;
}

function makeGetMessageTemplatesInboxes() {
  return createSelector([getAnswer, getInboxes], (answer, inboxes) => {
    if (!answer || answer.showInAllInboxes) {
      return undefined;
    }

    return _(answer.inboxIds)
      .map((id) => inboxes[id])
      .compact()
      .sortBy((i) => i.name.toLowerCase())
      .value();
  });
}

/*
 * Component.
 */

const SettingsAnswersInboxesCell: FC<SettingsAnswersInboxesCellProps> = (props) => {
  const {
    isSelected,
    isHovering,
    isLoading,
    size,
    settings,
    index,
    shouldShowStickyGradient,
    shouldRemoveTopBorderRadius,
    shouldRemoveBottomBorderRadius,
    messageTemplatesInboxes,
  } = props;

  return (
    <InboxesCell
      isSelected={isSelected}
      isHovering={isHovering}
      isLoading={isLoading}
      size={size}
      settings={settings}
      index={index}
      inboxes={messageTemplatesInboxes}
      value={props.value}
      shouldShowStickyGradient={shouldShowStickyGradient}
      shouldRemoveTopBorderRadius={shouldRemoveTopBorderRadius}
      shouldRemoveBottomBorderRadius={shouldRemoveBottomBorderRadius}
    />
  );
};

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsAnswersInboxesCellContainerProps>()(() => ({
  messageTemplatesInboxes: makeGetMessageTemplatesInboxes(),
}));

export const SettingsAnswerInboxesCellContainer = connect(mapStateToProps)(SettingsAnswersInboxesCell);
